module.exports = __webpack_public_path__ + "media/images/recruitment/blog/blog-1-33a0ad46f6551e753f7fccfd67c98bb6.jpg";